import React from "react"
import { NotificationRow } from "./notification-row"

export function NotificationsList({ topics }) {
  return (
    <ul className="list-none p-0">
      {topics.map(topic => (
        <NotificationRow key={topic.id} {...topic} />
      ))}
    </ul>
  )
}
